import React from 'react';

const About: React.FC = () => {
  return (
    <div className="min-h-screen bg-black relative overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-[#26ab4d]/25 via-black to-[#1e8a3f]/25"></div>
        <div className="absolute inset-0 bg-gradient-radial from-[#26ab4d]/10 via-transparent to-transparent" style={{
          background: 'radial-gradient(circle at 20% 30%, rgba(38, 171, 77, 0.15) 0%, transparent 50%), radial-gradient(circle at 80% 70%, rgba(30, 138, 63, 0.15) 0%, transparent 50%)'
        }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center min-h-screen">
        <div className="container mx-auto px-[1.5rem] sm:px-[2rem] py-[5rem] sm:py-[7rem] lg:py-[8rem]">
          <div className="max-w-4xl mx-auto text-center px-2 sm:px-0">
            <h1 className="text-[1.5rem] sm:text-[1.75rem] lg:text-[2rem] xl:text-[3rem] 2xl:text-[4.5rem] font-black text-[#ffffff] mb-4 xl:mb-6 leading-tight break-words">
              We are still working on this <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#26ab4d] to-[#1e8a3f]">page</span>.. stay tuned!!
            </h1>
            <p className="text-[0.8125rem] sm:text-[0.875rem] lg:text-[0.875rem] xl:text-[1rem] text-[#ffffff] leading-relaxed">
              Our knowledge base is coming soon with comprehensive resources, documentation, and insights about Bargad.ai's fraud prevention solutions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
